import { defineComponent, onBeforeMount, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { numberFormat } from '@/utils/helpers';
import useTransactionsStore from '@/store/modules/transactions';
import { TransactTypes } from '@/types/transact';
import RateTimer from '../general/RateTimer.vue';
var TransactionType = TransactTypes.TransactionType;
export default defineComponent({
    name: 'CurrencyRate',
    emits: ['refresh'],
    components: {
        RateTimer,
    },
    props: {
        sourceCurrency: {
            type: String,
            required: true,
        },
        destCurrency: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const transactionsStore = useTransactionsStore();
        const { usdRate, currentRate, rates, txType } = storeToRefs(transactionsStore);
        const sourceCurrencyValue = ref(props.sourceCurrency);
        const destCurrencyValue = ref(props.destCurrency);
        function setRates() {
            if (txType.value === TransactionType.BUY) {
                usdRate.value = transactionsStore.getCurrencyRate(sourceCurrencyValue.value);
                currentRate.value = transactionsStore.getCurrencyRate(destCurrencyValue.value);
            }
            else {
                usdRate.value = transactionsStore.getCurrencySellRate(sourceCurrencyValue.value);
                currentRate.value = transactionsStore.getCurrencySellRate(destCurrencyValue.value);
            }
        }
        /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
        watch(rates, _ => {
            setRates();
        });
        onBeforeMount(() => {
            setRates();
        });
        return {
            sourceCurrencyValue,
            destCurrencyValue,
            usdRate,
            currentRate,
            numberFormat,
        };
    },
});
